/**
 * 书体尺寸：参考实现的绝对尺寸按同一比例尺放大后的各项常量。
 */

export var BOOK_W = 1.5;
// 参考七本的平均尺度（用来定比例尺与兜底尺寸）
var REF_W = 1.029;
var REF_H = 1.56;
var REF_T = 0.263;
// 参考实现七本书**各有各的宽高厚**（照抄它的 BOOKS）：
//     codex 1.02×1.58×0.26 / claude 1.10×1.46×0.29 / cursor 0.92×1.52×0.22 /
//     antigravity 1.08×1.68×0.25 / figma 1.00×1.48×0.30 / framer 0.96×1.57×0.24 /
//     xcode 1.12×1.63×0.28
// 宽高比 0.605~0.753。我们按索引轮着用，相邻两本比例不同 —— 整排书才会像
// 参考那样有节奏，而不是一排一模一样的方块。（尺寸按比例尺放大，构造常数不变，
// 这一点和参考一致：它的封板/书脊/包边是绝对尺寸，不随书的宽高变。）
export var BOOK_SIZES = [
    [1.02, 1.58, 0.26],
    [1.10, 1.46, 0.29],
    [0.92, 1.52, 0.22],
    [1.08, 1.68, 0.25],
    [1.00, 1.48, 0.30],
    [0.96, 1.57, 0.24],
    [1.12, 1.63, 0.28]
];
// ==========================================================================
// 书体构造：**把参考实现的绝对尺寸按同一个比例尺放大**
// --------------------------------------------------------------------------
// complete-shelf 的七本书是 1.02~1.12 宽 × 1.46~1.68 高（平均 1.08 × 1.59），
// 它把全部构造细节写死在这个尺度上：
//     封板 0.032、书脊宽 0.082、书脊板 0.014、书芯 0.27、
//     页比封面窄 0.074 / 矮 0.068、封面图案内缩 0.007、环衬内缩 0.045、
//     包边 0.018、封板圆角 0.0045、合页沟宽 0.012 / 距书脊 0.038
// 我们的书是 1.5 × 2.2（宽高比 0.682，正好落在它七本的区间里），
// 所以把这些常数**乘同一个比例尺**（1.5 / 1.08 ≈ 1.39）—— 之前是直接照抄
// 那些绝对值，等于"书放大了、细节没跟着放大"，封板/书脊/包边全都偏薄，
// 立体感和参考差一截。
// 唯一**故意不跟**的是书脊板厚：用户两轮反馈原尺寸太薄，这里保持加厚后的 0.026。
// ==========================================================================
export var REF_SCALE = BOOK_W / REF_W;             // ≈ 1.458
// 兜底尺寸 = 参考七本的平均值 × 比例尺（没指定尺寸的书用它）
export var BOOK_H = REF_H * REF_SCALE;
export var BOOK_T = REF_T * REF_SCALE;             // 书芯厚度（不含封板）
export var BOARD_T = 0.032 * REF_SCALE;            // 封板厚度
export var SPINE_W = 0.082 * REF_SCALE;            // 书脊宽度
export var SPINE_BOARD = 0.026;                    // 书脊板厚（用户要求：比参考厚）
export var PAGE_DEPTH = BOOK_T - 0.026 * REF_SCALE;
// 书页比封面小多少（参考：宽 0.074 / 高 0.068，形成"封面外伸"）
export var PAGE_INSET_W = 0.074 * REF_SCALE;
// 上下留边（封面比页高的那圈）比参考再收一点：参考 0.068 是在它 1.56 高的书上，
// 我们的书在画面里更高，同样的比例换算出来"上下的纸边离封面太远"很明显。
export var PAGE_INSET_H = 0.05 * REF_SCALE;
// 封板四角圆角（参考 coverRadius 0.0045）
export var COVER_RADIUS = 0.0045 * REF_SCALE;
// 封面图案层相对封板的内缩（参考 coverArtInset 0.007）与环衬内缩（0.045）
export var ART_INSET = 0.007 * REF_SCALE;
export var ENDPAPER_INSET = 0.045 * REF_SCALE;
// 合页沟（hinge groove）：宽 0.012、距书脊 0.038（参考值 × 比例尺）
export var GROOVE_W = 0.012 * REF_SCALE;
export var GROOVE_X = 0.038 * REF_SCALE;
// 封面内侧的包边（turn-in）宽度。它是**封面边缘**与**内侧纸页边缘**之间
// 那圈布边的宽度，两处必须用同一个值，否则中间会露出一道封面图案。
export var TURN_IN = 0.018 * REF_SCALE;
export var PLANK_TOP = -1.16;          // 木板顶面高度：所有书都按这个高度「落座」
// 搁板厚度。参考的 walnut-shelf 是 0.28（书高 1.46 → 板厚约占 19%），
// 我原来只有 0.2（书高 2.2 → 只占 9%），板子明显偏薄、没有"木搁板"的份量。
// 对齐到参考的绝对值 0.28。
export var PLANK_H = 0.28;
